import isString from 'lodash/isString';

export default function externalUrl(value) {
  if (!value || !isString(value)) {
    return value;
  }
  return value.replace('OLD_EXTERNAL_URL', 'NEW_EXTERNAL_URL');
}
